import jwtDecode from "jwt-decode";

import {
  getDecryptPayload,
  encryptObject,
  setItemToStorage,
} from "../../system";
import { updateObject } from "../../shared/utility";
import {
  userType,
  EMPTY_STRING,
  loginConstants,
  globalConstants,
  numberConstants,
} from "../../constants";

// initializing the token from the browser
const payload = getDecryptPayload();

const token = payload.token || EMPTY_STRING;
const userId = (payload.user && payload.user.id) || numberConstants.ZERO;
const userName = (payload.user && payload.user.userName) || EMPTY_STRING;
const userAddress = (payload.user && payload.user.currentAddress) || null;

// decoding JWT to get user type
const decodedToken = token && jwtDecode(token);

// default state
const initialState = {
  userAddress,
  userId,
  userName,
  userType: decodedToken?.UserType,
  isAuthenticated:
    token.length > 0 &&
    (userType.USER === decodedToken.UserType ||
      decodedToken.UserType === userType.ADMIN),
  isEmailedVerified: true,
  passwordChanged: false,
};

// manupilating the state based on actions and returning the state
export const authentication = (state = initialState, action) => {
  switch (action.type) {
    case loginConstants.USER_LOGIN + globalConstants.SUCCESS:
      return updateObject(state, {
        isAuthenticated: true,
        userId: action.data.user.id,
        userName: action.data.user.userName,
        passwordChanged: true,
        userAddress: action.data.user.currentAddress,
      });
    case loginConstants.USER_LOGIN + globalConstants.FAILURE:
      return updateObject(state, {
        userAddress: null,
        userName: EMPTY_STRING,
        isAuthenticated: false,
      });
    case loginConstants.EMAIL_VERIFIED:
      return updateObject(state, { isEmailedVerified: action.data });
    case loginConstants.UPDATE_CURRENT_ADDRESS + globalConstants.SUCCESS:
      const ciphertext = encryptObject({
        ...payload,
        user: {
          ...payload.user,
          currentAddress: action.data,
        },
      });
      
      setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);
      return updateObject(state, { userAddress: action.data });

    default:
      return state;
  }
};
